import {
  ApiNewDokumentPowiazanyDalDto,
  EgibObject,
  LawPerson,
  Place,
  Street,
} from '@gk/gk-modules';
import { WorkspaceState } from '../../../../services/request-workspace-state/request-workspace-state.model';
import {
  ApplicantRequest,
  ApplicantRequestDto,
  DocumentationFormType,
} from '../../../../shared/base-new-request/base-new-request.model';
import { Shipping } from '../../../../shared/shipping-form/shipping-form.model';
import {
  SPPOwnershipForm,
  SPPParcelArea,
} from '../new-request-form/new-request-form.model';

export interface SPPNewRequestDto extends ApplicantRequestDto {
  MiejscId: string | number;
  Miejsc: string;
  UlicaId: string | number;
  Ulica: string;
  InfoDodatkowe: string;
  Uzasadnienie: string;
  Wspolwlasciciel: boolean;
  UzytkownikWieczysty: boolean;
  CzescDzialki: boolean;
  PrzylegaDoNieruchomosciBedacejWlasnoscia: boolean;
}

export class SPPNewRequest extends ApplicantRequest {
  constructor(
    lawPerson: LawPerson,
    public place: Place,
    public street: Street,
    documentationForm: DocumentationFormType,
    shippingForm: Shipping,
    public comments: string,
    public reason: string,
    public ownershipForm: SPPOwnershipForm,
    public parcelArea: SPPParcelArea,
    public adjacentProperty: boolean,
    public other: boolean,
  ) {
    super(
      lawPerson,
      undefined,
      documentationForm,
      shippingForm,
      undefined,
      undefined,
      undefined,
    );
  }

  static fromAppToApi(
    data: SPPNewRequest,
    issueRanges: string[],
    parcels: EgibObject[],
    files: ApiNewDokumentPowiazanyDalDto[],
  ): SPPNewRequestDto {
    return {
      ...ApplicantRequest.mapCommonFields({
        data,
        issueRanges,
        parcels,
        files,
      }),
      MiejscId: data.place?.id,
      Miejsc: data.place?.name,
      UlicaId: data.street?.id,
      Ulica: data.street?.name,
      InfoDodatkowe: data.other ? data.comments : undefined,
      Uzasadnienie: data.reason,
      Wspolwlasciciel: data.ownershipForm === SPPOwnershipForm.CoOwner,
      CzescDzialki: data.parcelArea === SPPParcelArea.PartOfParcel,
      PrzylegaDoNieruchomosciBedacejWlasnoscia: data.adjacentProperty,
      UzytkownikWieczysty:
        data.ownershipForm === SPPOwnershipForm.PerpetualUser,
    };
  }
}

export interface SupplementaryParcelPurchaseRequestFormWorkspaceState
  extends WorkspaceState {
  formValue: SPPNewRequest;
  parcels: EgibObject[];
  issueRanges: string[];
}
